function getLsTenantIdTsg (authData: any) {
  const loggingService = authData.instances.get("logging_service");

  return loggingService == null ? undefined : loggingService.tenant_id;
}

export default getLsTenantIdTsg;
